import type { TOC } from '@ember/component/template-only';
import type { RecommendationExtension as RecommendationModel } from 'tio-data/data/resources/recommendation.ext';
import IdrDashboard0726Results from 'tio-employee/components/idr-dashboard-0726/results';

interface S {
  Args: {
    model: RecommendationModel;
  };
}

const tmpl: TOC<S> = <template><IdrDashboard0726Results @recommendation={{@model}} /></template>;

export default tmpl;
